<template>
  <div>
    <UpdateGymNameModal
      :show="showUpdateGymNameModal"
      :entry="entry"
      :event="event"
      @close-modal="showUpdateGymNameModal = false"
    />
    <b-dropdown aria-role="list">
      <button slot="trigger" slot-scope="{ active }" class="button">
        <span>Actions</span>
        <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
      </button>
      <b-dropdown-item v-if="!entry.paid" aria-role="listitem">
        <a href="" @click.prevent="markAsPaid(entry)">Mark as Paid</a>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="entry.paid && entry.paymentmethod === 'EFT' && !entry.eftchecked"
        aria-role="listitem"
      >
        <a href="" @click.prevent="verifyPop(entry)">Verify Proof of Payment</a>
      </b-dropdown-item>
      <b-dropdown-item v-if="canSendPaymentRequest" aria-role="listitem">
        <a href="" @click.prevent="sendPaymentRequest(entry)"
          >Send Request Payment</a
        >
      </b-dropdown-item>
      <b-dropdown-item v-if="entry.entrytype === 'Team'" aria-role="listitem">
        <a href="" @click.prevent="updateTeamName(entry)">Update Team Name</a>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem">
        <a href="" @click.prevent="updateGymName(entry)">Update Gym Name</a>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem">
        <a href="" @click.prevent="changeCategory(entry)">Change Category</a>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem" v-if="entry.entrytype === 'Team'">
        <a href="" @click.prevent="viewTeam(entry)">View Team</a>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem">
        <a href="" @click.prevent="deleteEntry(entry)">Delete</a>
      </b-dropdown-item>
    </b-dropdown>
    <b-modal :active.sync="showChangeCategoryModal" has-modal-card>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Change Category</p>
        </header>
        <section class="modal-card-body">
          <b-select v-model="newCategory">
            <option
              v-for="category in filteredCategories"
              :key="category.category"
            >
              {{ category.category }}
            </option>
          </b-select>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="showChangeCategoryModal = false"> Cancel </b-button>
          <b-button type="is-primary" @click="updateCategory">Update</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import EventEntryApi from '@/api/event-entry'
import UpdateGymNameModal from '@/components/UpdateGymNameModal'
import { addHours } from 'date-fns'

export default {
  name: 'EntryActions',
  components: {
    UpdateGymNameModal,
  },
  props: {
    entry: {
      type: Object,
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showChangeCategoryModal: false,
      showUpdateGymNameModal: false,
      newCategory: '',
      item: this.entry,
    }
  },
  computed: {
    filteredCategories() {
      if (this.entry.category) {
        return this.event.categories.filter(
          (category) => category.entrytype === this.entry.entrytype
        )
      }
      return []
    },
    canSendPaymentRequest: {
      cache: false,
      get() {
        return (
          !this.entry.paid &&
          (!this.entry.lastpaymentrequest ||
            (this.entry.lastpaymentrequest &&
              addHours(new Date(this.entry.lastpaymentrequest), 24) <
                new Date()))
        )
      },
    },
  },
  methods: {
    async verifyPop(entry) {
      await EventEntryApi.verifyPop(entry._id)
      entry.eftchecked = true
    },
    async sendPaymentRequest(entry) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to send a payment request email?',
        onConfirm: async () => {
          await EventEntryApi.sendPaymentRequest(entry._id)
          this.entry.lastpaymentrequest = new Date()
          this.$forceUpdate()
          this.$buefy.toast.open({
            message: 'Payment request email sent.',
            position: 'is-top',
            type: 'is-success',
          })
        },
      })
    },
    viewTeam(entry) {
      this.$emit('show-team-modal', entry)
    },

    async markAsPaid(entry) {
      await EventEntryApi.markAsPaid(entry._id)
      entry.paid = true
      this.$buefy.toast.open({
        message: 'Entry marked as paid.',
        position: 'is-top',
        type: 'is-success',
      })
    },
    updateGymName() {
      this.showUpdateGymNameModal = true
    },
    updateTeamName(entry) {
      this.$buefy.dialog.prompt({
        title: 'Update Team Name',
        message: 'Please enter the new team name',
        trapFocus: true,
        onConfirm: async (value) => {
          await EventEntryApi.updateTeamName({
            _id: entry._id,
            teamname: value,
          })
          entry.teamname = value
          this.$buefy.toast.open({
            message: 'Team name updated.',
            position: 'is-top',
            type: 'is-success',
          })
        },
      })
    },
    changeCategory() {
      this.showChangeCategoryModal = true
    },
    async updateCategory() {
      await EventEntryApi.updateCategory({
        _id: this.entry._id,
        category: this.newCategory,
      })
      this.entry.category = this.newCategory
      this.$buefy.toast.open({
        message: 'Category updated.',
        position: 'is-top',
        type: 'is-success',
      })
      this.showChangeCategoryModal = false
    },
    deleteEntry(entry) {
      let vm = this
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this entry?',
        onConfirm: async () => {
          await EventEntryApi.deleteEntry(entry)
          vm.$emit('deleted', this.entry._id)
          this.$buefy.toast.open({
            message: 'Entry deleted successfully.',
            position: 'is-top',
            type: 'is-success',
          })
        },
      })
    },
  },
}
</script>
